"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavbarLink = function NavbarLink(_ref) {
  var children = _ref.children,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      disabled = _ref.disabled,
      withBadge = _ref.withBadge,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      onClick = _ref.onClick;
  var linkClasses = (0, _classnames.default)('menu-item', {
    'co--active': active,
    'co--disabled': disabled,
    loading: loading,
    'menu-item__badge--left': withBadge
  });

  var onClickHandler = function onClickHandler(e) {
    if (!disabled && !loading) {
      e.stopPropagation();
      onClick();
    }
  };

  return _react.default.createElement("a", {
    className: linkClasses,
    onClick: onClickHandler
  }, _react.default.createElement("span", {
    className: "menu-item__content"
  }, children));
};

NavbarLink.propTypes = {
  children: _propTypes.default.node.isRequired,
  active: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  withBadge: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  onClick: _propTypes.default.func.isRequired
};
var _default = NavbarLink;
exports.default = _default;
NavbarLink.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "NavbarLink",
  "props": {
    "active": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "loading": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "withBadge": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    }
  }
};